import React, { FC, createContext, useContext } from 'react'

interface DragHandleProps extends React.HTMLAttributes<HTMLDivElement> {
  children?: React.ReactNode
}

// Context used to pass listeners from useSortable up to arbitrary drag handle
const DragListenersContext = createContext<Record<string, any> | null>(null)

/**
 * A pure HOC that wraps the consumer's drag handle element with drag listeners.
 * All styling and props are passed through to the consumer's element.
 */
const DragHandle: FC<DragHandleProps> = ({ children, ...props }) => {
  const listeners = useContext(DragListenersContext)

  return (
    <div {...listeners} {...props}>
      {children}
    </div>
  )
}

/**
 * Hook that returns the DragHandle component for use within render functions.
 * This provides a cleaner API than passing dragHandleTools through render props.
 */
const useDragHandle = () => DragHandle

export { DragListenersContext, DragHandle, useDragHandle }
export type { DragHandleProps }
